// VPS kodeinda.cloud — gitignored (environment.local.ts)
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {
    baseUrl: 'https://patient-api.cp.kodeinda.cloud/patient'
  },
  publicApi: {
    baseUrl: 'https://public-api.cp.kodeinda.cloud/public'
  },
  stripe: {
    publicKey: 'pk_test_ywGdKfFfDVpfJ4om9n0dQLUX00YluPBHDk'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyBMG4318ece8D738Ok8TBZiOqXZwvYglmY',
    authDomain: 'portals-care.firebaseapp.com',
    databaseURL: 'https://portals-care-default-rtdb.firebaseio.com',
    projectId: 'portals-care',
    storageBucket: 'portals-care.appspot.com',
    messagingSenderId: '338418690450',
    appId: '1:338418690450:web:00cb574dc78f7093c5b94b',
    measurementId: 'G-NTRESSKK01'
  }
};
